import React from 'react';

function Device(props) {
  const {label, percentage} = props;

  return <dl className="list_statistic">
    <dt className="tit_statistic_type1">{label}</dt>
    <dd className="txt_data">{percentage}%</dd>
  </dl>
}


function InflowDevice(props) {
  const {label, list} = props.data;

  return <div className="detail_data detail_data_device">
    <h4 className="tit_statistic_type1">{label}</h4>
    <div className="bar_data">
            <span className="current_data">
                <span className="inner_current data_type3">100%</span>
            </span>
    </div>
    {list.map((item, index) => <Device key={index} label={item.label} percentage={item.percentage}/>)}
  </div>

}

export default InflowDevice;
